import http from "./http";

function getDriver(data) {
  return http.post(`driver_get`, data);
}
function addDriver(data) {
  return http.post(`driver_add`, data);
}
function updateDriver(data) {
  return http.post(`driver_update`, data);
}
function deleteDriver(data) {
  return http.post(`driver_delete`, data);
}

const DriverService = {
  getDriver,
  addDriver,
  updateDriver,
  deleteDriver,
};

export default DriverService;
// ====================================
